import { useEffect } from 'react';
import type { SemanticFramework } from '../../../services/semanticService';

export const useUIState = (
  selectedFramework: SemanticFramework | null,
  setShowConfigSection: (show: boolean) => void
) => {
  // Update showConfigSection when we have results
  useEffect(() => {
    // Hide config section if we have results
    if (selectedFramework) {
      setShowConfigSection(false);
    }
  }, [selectedFramework, setShowConfigSection]);
};

export default useUIState;
